// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1at-d","rootCenter":"LoadMoreObserver_rootCenter__3nAQB","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__18BKe"};